export default "__VITE_ASSET__DcWPE_vN__";